import TemplateDefaultFileTypes from '../constants/template_default_file_types';

export default class Template {
	_id;
	_name;
	_fileTypes;
	_defaultModel;
	_fields;
	_permissionType;
	_pdfSigned;
	_allowedFileTypes;
	_maxFileSizeAllowed;
	_summaryEnabled;

	constructor({ id, name, fileTypes = TemplateDefaultFileTypes, defaultModel = null, fields = {}, permissionType = null, pdfSigned = false, allowedFileTypes = {}, maxFileSizeAllowed, summaryEnabled = false }) {
		this.id = id;
		this.name = name;
		this.fileTypes = fileTypes;
		this.defaultModel = defaultModel;
		this.fields = fields;
		this.permissionType = permissionType;
		this.pdfSigned = pdfSigned;

		this.allowedFileTypes = allowedFileTypes;
		this.maxFileSizeAllowed = maxFileSizeAllowed;

		this.summaryEnabled = summaryEnabled;
	}

	get id() {
		return this._id;
	}

	set id(value) {
		this._id = value;
	}

	get name() {
		return this._name;
	}

	set name(value) {
		this._name = value;
	}

	get fileTypes() {
		return this._fileTypes;
	}

	set fileTypes(value) {
		this._fileTypes = value;
	}

	get defaultModel() {
		return this._defaultModel;
	}

	set defaultModel(value) {
		this._defaultModel = value;
	}

	get fields() {
		return this._fields;
	}

	set fields(value) {
		this._fields = value;
	}

	get permissionType() {
		return this._permissionType;
	}

	set permissionType(value) {
		this._permissionType = value;
	}

	get pdfSigned() {
		return this._pdfSigned;
	}

	set pdfSigned(value) {
		this._pdfSigned = value;
	}

	get allowedFileTypes(){
		return this._allowedFileTypes;
	}

	set allowedFileTypes(value){
		this._allowedFileTypes = value;
	}

	get maxFileSizeAllowed(){
		return this._maxFileSizeAllowed;
	}

	set maxFileSizeAllowed(value){
		this._maxFileSizeAllowed = value;
	}

	get summaryEnabled() {
		return this._summaryEnabled;
	}

	set summaryEnabled(value) {
		this._summaryEnabled = value;
	}
}
